<ng-template #jacketArtTemplate let-fullRecord>
  <ng-container *ngIf="fullRecord.jacketArt.link; else noLink">
    <a [href]="fullRecord.jacketArt.link" target="_blank">
      <img
        [alt]="fullRecord.title"
        [src]="fullRecord.jacketArt.small"
        [title]="fullRecord.title"
        class="width-95 max-height-160"
        style="border: 0px"
        onerror="this.onerror=null;this.alt='Image not available';this.src='https\:\/\/www5.auto-graphics.com/v6assets/no-image-foundlrg.png?local'"
      />
    </a>
  </ng-container>
  <ng-template #noLink>
    <img
      [alt]="fullRecord.title"
      [src]="fullRecord.jacketArt.small"
      [title]="fullRecord.title"
      class="width-95 max-height-160"
      style="border: 0px"
      onerror="this.onerror=null;this.alt='Image not available';this.src='https\:\/\/www5.auto-graphics.com/v6assets/no-image-foundlrg.png?local'"
    />
  </ng-template>
</ng-template>
<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<!-- Tabs -->
<ng-container *ngIf="!loading && fullRecord">
  <div
    id="page-header"
    fxLayout="row"
    fxLayoutAlign="start center"
    class="sticky back-body"
    [ngClass]="{
      'mat-elevation-z1 ': scrolled
    }"
  >
    <div fxFlex="nogrow">
      <button
        *ngIf="hasGoBack"
        mat-icon-button
        matTooltip="Return to results"
        type="button"
        aria-label="Return To Results"
        (agInteract)="goBack()"
      >
        <mat-icon>arrow_back_ios</mat-icon>
      </button>
    </div>
    <div *ngIf="scrolled" fxFlex="auto">
      <div class="ag-px-sm ellipsis" style="max-width: 400px">
        <div *ngIf="fullRecord.title" class="mat-title ellipsis" [title]="fullRecord.title">
          {{ fullRecord.title }}
        </div>
        <div
          *ngIf="fullRecord.author"
          class="mat-subheading-2 ellipsis"
          [title]="fullRecord.author"
        >
          {{ fullRecord.author }}
        </div>
      </div>
    </div>
    <div
      *ngIf="
        (fullRecord.fullRecordSettings.fullRecordTabs.length &&
          (layoutService.screenRange$ | async).gtSm) ||
        (fullRecord.fullRecordSettings.fullRecordTabs.length &&
          (layoutService.screenRange$ | async).ltMd &&
          !scrolled)
      "
      fxFlex="grow"
      fxFill
    >
      <div style="text-align: center">
        <ng-container
          *ngFor="let fullRecordTab of fullRecord.fullRecordSettings.fullRecordTabs"
          [ngSwitch]="fullRecordTab.value"
        >
          <ng-container *ngIf="fullRecordTab.isDefault">
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Details">
              <!-- details scroll to link -->
              <a
                *ngIf="detailsTabLabel"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('details')"
                >{{ detailsTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.More_About_This_Title">
              <!-- more about this title scroll to link -->
              <a
                *ngIf="showMoreAboutThisTitle"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('moreAbout')"
              >
                {{ moreAboutTabLabel }}
              </a>
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Where_To_Find">
              <!-- where to find it scroll link -->
              <a
                *ngIf="fullRecord.holdings"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('whereIsIt')"
                >{{ whereToTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.GoodreadsReviews">
              <!-- review scroll to link -->
              <a
                *ngIf="
                  fullRecord.fullRecordSettings.displayGoodreadsReview &&
                  fullRecord.reviews?.goodReadReviewData
                "
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('reviews')"
                >Goodreads® Reviews</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.MARC_Display">
              <!-- marc display scroll to link -->
              <a
                *ngIf="fullRecord.fullRecordSettings.displayMARC && !kids && marcTabLabel"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('marc')"
                >{{ marcTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Syndetics_Unbound">
              <!-- syndetics display scroll to link -->
              <a
                *ngIf="showSyndeticsUnbound && !kids"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('syndetics_unbound')"
                >{{ syndeticsTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Novelist">
              <!-- novelist display scroll to link -->
              <a
                *ngIf="fullRecord.fullRecordSettings.displayNovelist && !kids"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('novel')"
                >{{ novelistTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.CLCD">
              <!-- clcd display scroll to link -->
              <a
                *ngIf="showClcd && clcdLoaded"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('clcd')"
                >{{ clcdTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Shelf_Browse">
              <!-- shelf browse scroll to link -->
              <a
                *ngIf="
                  fullRecord.shelfBrowseLocations &&
                  fullRecord.fullRecordSettings.displayShelfBrowse &&
                  shelfTabLabel
                "
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('shelf')"
                >{{ shelfTabLabel }}</a
              >
            </ng-container>
            <ng-template *ngSwitchDefault>
              <!-- required so the switch does not hard break -->
            </ng-template>
          </ng-container>
        </ng-container>
        <ng-container
          *ngFor="let firstTab of fullRecord.fullRecordSettings.fullRecordTabs"
          class="inline-block d-sm-inline-block d-md-inline-block"
          [ngSwitch]="firstTab.value"
        >
          <ng-container *ngIf="!firstTab.isDefault">
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Details">
              <!-- details scroll to link -->
              <a
                *ngIf="detailsTabLabel"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('details')"
                >{{ detailsTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.More_About_This_Title">
              <!-- more about this title scroll to link -->
              <a
                *ngIf="showMoreAboutThisTitle"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('moreAbout')"
              >
                {{ moreAboutTabLabel }}
              </a>
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Where_To_Find">
              <!-- where to find it scroll link -->
              <a
                *ngIf="fullRecord.holdings"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('whereIsIt')"
                >{{ whereToTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.GoodreadsReviews">
              <!-- review scroll to link -->
              <a
                *ngIf="
                  fullRecord.fullRecordSettings.displayGoodreadsReview &&
                  fullRecord.reviews?.goodReadReviewData
                "
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('reviews')"
                >Goodreads® Reviews</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.MARC_Display">
              <!-- marc display scroll to link -->
              <a
                *ngIf="fullRecord.fullRecordSettings.displayMARC && !kids && marcTabLabel"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('marc')"
                >{{ marcTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Syndetics_Unbound">
              <!-- syndetics display scroll to link -->
              <a
                *ngIf="showSyndeticsUnbound && !kids"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('syndetics_unbound')"
                >{{ syndeticsTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Novelist">
              <!-- novelist display scroll to link -->
              <a
                *ngIf="fullRecord.fullRecordSettings.displayNovelist && !kids"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('novel')"
                >{{ novelistTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.CLCD">
              <!-- clcd display scroll to link -->
              <a
                *ngIf="showClcd && clcdLoaded"
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('clcd')"
                >{{ clcdTabLabel }}</a
              >
            </ng-container>
            <ng-container *ngSwitchCase="fullRecordOptionTabs.Shelf_Browse">
              <!-- shelf browse scroll to link -->
              <a
                *ngIf="
                  fullRecord.shelfBrowseLocations &&
                  fullRecord.fullRecordSettings.displayShelfBrowse &&
                  shelfTabLabel
                "
                class="record-category-links"
                tabindex="0"
                (agInteract)="scrollToSectionById('shelf')"
                >{{ shelfTabLabel }}</a
              >
            </ng-container>
            <ng-template *ngSwitchDefault>
              <!-- required so the switch does not hard break -->
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div *ngIf="(layoutService.screenRange$ | async).ltMd && scrolled" fxFlex="nogrow">
      <button
        mat-icon-button
        id="ilsdesk"
        type="button"
        [attr.aria-label]="userData.isStaff ? 'Staff Actions' : 'Other Actions'"
        [matMenuTriggerFor]="action"
      >
        <mat-icon>more_vert</mat-icon>
      </button>
      <mat-menu #action="matMenu" dense>
        <ag-menu-items-actions
          [userData]="userData"
          [fullRecord]="fullRecord"
          [showFormat]="showFormat"
          (addItem)="goToAddItem()"
          (addItemToList)="addToList()"
          (printItem)="print()"
          (emailItem)="email()"
          (multiCopy)="multiCopyForm()"
        >
        </ag-menu-items-actions>
      </mat-menu>
    </div>
    <!-- Guest -->
    <div
      *ngIf="userData.isPatron && fullRecord.targetType === 'BX' && BxData"
      style="font-style: italic"
      class="width-100 padding-0-25"
    >
      <a *ngIf="showMessageBX" class="isDisabled">{{ messageTextBX }}</a>
    </div>
  </div>

  <div>
    <div class="width-100">
      <!-- mobile < 768px -->
      <div class="col-12 d-md-none clearfix">
        <div
          *ngIf="fullRecord.author"
          class="record-author author-class"
          [title]="fullRecord.author"
          [innerHTML]="'Author: ' + fullRecord.author"
        ></div>
        <h1
          *ngIf="fullRecord.title"
          class="record-title title-class"
          [title]="fullRecord.title"
          [innerHTML]="'Title:' + fullRecord.title"
        ></h1>
        <div *ngIf="fullRecord.format" class="record-isbn title-class" [title]="fullRecord.format">
          <i [ngClass]="'fa ag-media-' + fullRecord.format_Short + ' fa-2x'"></i
          >{{ fullRecord.format }}
        </div>
        <div
          *ngIf="fullRecord.targetName"
          class="record-author title-class"
          [title]="fullRecord.targetName"
          [innerHTML]="'Found In: ' + fullRecord.targetName"
        ></div>
        <div
          *ngIf="fullRecord.targetType === 'AV' && fullRecord.holdings && !kids"
          class="record-available text-start"
        >
          Availability:
          <span *ngIf="fullRecord.holdings?.totalAvailable !== 0">
            {{ fullRecord.holdings?.totalAvailable }}
          </span>
          <span *ngIf="fullRecord.holdings?.totalAvailable === 0"> 0 </span>
          <span *ngIf="fullRecord.holdings?.totalCopies">
            (of {{ fullRecord.holdings?.totalCopies }})</span
          >
        </div>
        <div
          *ngIf="
            (fullRecord.targetType === 'ZZ' || fullRecord.targetType === 'WM') &&
            fullRecord.holdings &&
            !kids &&
            fullRecord.holdings.totalCopies > 0
          "
          class="record-available text-start"
        >
          Availability:
          <span *ngIf="fullRecord.holdings?.totalAvailable !== 0">
            {{ fullRecord.holdings?.totalAvailable }}
          </span>
          <span *ngIf="fullRecord.holdings?.totalAvailable === 0"> 0 </span>
          <span *ngIf="fullRecord.holdings?.totalCopies">
            (of {{ fullRecord.holdings?.totalCopies }})</span
          >
        </div>
        <!-- 3rd Party Integrations. -->
        <!-- Axis 360 -->
        <div *ngIf="fullRecord.targetType === 'BX'" class="record-available text-start">
          Availability:
          <span *ngIf="BxData" class="width-100">
            <span *ngIf="BxData.availableCopies"> {{ BxData?.availableCopies }} </span>
            <span *ngIf="BxData.totalCopies"> (of {{ BxData?.totalCopies }})</span>
          </span>
        </div>
        <!-- OverDrive -->
        <div
          *ngIf="fullRecord.targetType === 'OD' && fullRecord.details.fields.length"
          class="record-available text-start"
        >
          Availability:
          <span *ngFor="let details of fullRecord.details.fields">
            <span *ngIf="details.name === 'Availability'"> {{ details.value }} </span>
          </span>
        </div>
        <!-- Hoopla -->
        <div *ngIf="fullRecord.targetType === 'HP'" class="record-available text-start">
          Availability: {{ userData.isGuest ? 'Login Required' : hooplaItem?.availability }}
        </div>
        <div class="record-available text-start">
          <ng-container *ngIf="fullRecord.targetType === 'HP'; else holdsInQueueNonHoopla">
            <ng-container *ngIf="!userData?.isGuest && hooplaPurchaseModel === HOOPLA_TYPE.FLEX">
              <a style="pointer-events: none">{{ hooplaItem?.holdsInQueue }} Hold(s) in Queue</a>
            </ng-container>
          </ng-container>
          <ng-template #holdsInQueueNonHoopla>
            <div
              *ngIf="fullRecord.reserveOptions?.showHoldsInQueue"
              class="record-available text-start"
            >
              <a *ngIf="userData.isStaff" tabindex="0" (agInteract)="holdsInQueue()"
                >{{ fullRecord.reserveOptions.holsInQueueCount }} Hold(s) in Queue</a
              >
              <a *ngIf="userData.isPatron" style="pointer-events: none"
                >{{ fullRecord.reserveOptions.holsInQueueCount }} Hold(s) in Queue</a
              >
            </div>
          </ng-template>
        </div>
        <div class="record-image">
          <div *ngIf="fullRecord.jacketArt" class="jacketarturl inline text-start pointer">
            <ng-container
              *ngTemplateOutlet="jacketArtTemplate; context: { $implicit: fullRecord }"
            ></ng-container>
          </div>
          <div class="record-buttons mobile">
            <div *ngIf="showFulfillmentButton" class="width-100 margin-10-0">
              <button
                *ngIf="!kids; else showKidsButton"
                mat-raised-button
                color="primary"
                type="button"
                [attr.aria-label]="fulfillmentLabel"
                class="ag-mat-button-primary"
                type="button"
                (click)="fulfillItem()"
              >
                {{ this.fulfillmentLabel }}
              </button>
              <ng-template #showKidsButton>
                <img
                  alt="I want it"
                  src="./assets/images/kids-catalog/iwantit.png"
                  style="cursor: pointer"
                  tabindex="0"
                  (agInteract)="fulfillItem()"
                />
              </ng-template>
            </div>
            <ag-online-content *ngIf="!kids" [fullRecord]="fullRecord"></ag-online-content>

            <!-- 3rd Party Integrations -->
            <div *ngIf="fullRecord.targetType === 'BX'">
              <button
                *ngIf="canCheckOutBX"
                type="button"
                aria-label="Checkout Now"
                class="btn btn-primary"
                (click)="checkoutBX()"
              >
                Checkout Now
              </button>
              <button
                *ngIf="canHoldBX"
                type="button"
                aria-label="Place Hold"
                class="btn btn-primary"
                (click)="addHoldBX()"
              >
                Place Hold
              </button>
              <button
                *ngIf="canRemoveHoldBX"
                type="button"
                aria-label="Remove Hold"
                class="btn btn-primary"
                (click)="removeHoldBX()"
              >
                Remove Hold
              </button>
            </div>

            <ag-overdrive-fullrecord
              *ngIf="fullRecord.targetType === 'OD' && overDriveItem"
              [item]="overDriveItem"
              [format]="fullRecord.format"
              [isGuest]="userData.isGuest"
              (refreshItem)="refreshItem()"
              (placeHold)="placeOverDriveHold()"
              (selectedProduct)="changeOverdriveJacketArt($event)"
            >
            </ag-overdrive-fullrecord>

            <ag-hoopla-fullrecord
              *ngIf="fullRecord.targetType === 'HP'"
              [item]="hooplaItem"
              [format]="fullRecord.format"
              [purchaseModel]="hooplaPurchaseModel"
              [isGuest]="userData.isGuest"
              (refreshItem)="refreshItem()"
            >
            </ag-hoopla-fullrecord>

            <!-- Action Items -->
            <ag-item-actions-dropdown
              [userData]="userData"
              [fullRecord]="fullRecord"
              [showFormat]="showFormat"
              (addItem)="goToAddItem()"
              (addItemToList)="addToList()"
              (printItem)="print()"
              (emailItem)="email()"
              (multiCopy)="multiCopyForm()"
            >
            </ag-item-actions-dropdown>
          </div>
        </div>
      </div>

      <!-- tablet - 576px to (991px or 1199px) -->
      <div class="container-fluid d-none d-md-block d-lg-none clearfix">
        <div class="record-image clearfix">
          <div *ngIf="fullRecord.jacketArt" class="jacketarturl inline pointer">
            <ng-container
              *ngTemplateOutlet="jacketArtTemplate; context: { $implicit: fullRecord }"
            ></ng-container>
          </div>
          <div
            *ngIf="fullRecord.targetType === 'AV' && fullRecord.holdings && !kids"
            class="text-center text-truncate"
            style="font-weight: bold; font-size: 0.7em; margin-top: 1%"
          >
            Availability:
            <span *ngIf="fullRecord.holdings?.totalAvailable !== 0">
              {{ fullRecord.holdings?.totalAvailable }}
            </span>
            <span *ngIf="fullRecord.holdings?.totalAvailable === 0"> 0 </span>
            <span *ngIf="fullRecord.holdings?.totalCopies > 0">
              (of {{ fullRecord.holdings?.totalCopies }})</span
            >
            <span *ngIf="fullRecord.holdings?.totalCopies === 0"> (of 0)</span>
          </div>
          <div
            *ngIf="
              (fullRecord.targetType === 'ZZ' || fullRecord.targetType === 'WM') &&
              fullRecord.holdings &&
              !kids &&
              fullRecord.holdings.totalCopies > 0
            "
            class="text-truncate text-center"
            style="font-weight: bold; font-size: 0.7em; margin-top: 1%"
          >
            Availability:
            <span *ngIf="fullRecord.holdings?.totalAvailable !== 0">
              {{ fullRecord.holdings?.totalAvailable }}
            </span>
            <span *ngIf="fullRecord.holdings?.totalAvailable === 0"> 0 </span>
            <span *ngIf="fullRecord.holdings?.totalCopies">
              (of {{ fullRecord.holdings?.totalCopies }})</span
            >
          </div>
        </div>
        <div class="record-content clearfix">
          <div *ngIf="fullRecord.author" class="record-author">
            Author : {{ fullRecord.author }}
          </div>
          <h1 *ngIf="fullRecord.title" class="record-title">Title : {{ fullRecord.title }}</h1>
          <div *ngIf="fullRecord.format" class="record-author">
            Format : {{ fullRecord.format }}
          </div>
          <div *ngIf="fullRecord.targetName" class="record-author">
            Found In : {{ fullRecord.targetName }}
          </div>

          <!-- 3rd Party Integrations. -->
          <!-- OverDrive -->
          <div
            *ngIf="fullRecord.targetType === 'OD' && fullRecord.details.fields.length > 0"
            class="record-available"
          >
            Availability:
            <span *ngFor="let details of fullRecord.details.fields">
              <span *ngIf="details.name === 'Availability'"> {{ details.value }} </span>
            </span>
          </div>
          <!-- Hoopla -->
          <div *ngIf="fullRecord.targetType === 'HP'" class="record-available text-start">
            Availability: {{ userData.isGuest ? 'Login Required' : hooplaItem?.availability }}
          </div>
          <ng-container *ngIf="fullRecord.targetType === 'HP'; else holdsInQueueNonHoopla">
            <div
              *ngIf="!userData?.isGuest && hooplaPurchaseModel === HOOPLA_TYPE.FLEX"
              class="record-available text-center"
            >
              <a style="pointer-events: none">{{ hooplaItem?.holdsInQueue }} Hold(s) in Queue</a>
            </div>
          </ng-container>
          <ng-template #holdsInQueueNonHoopla>
            <div
              *ngIf="fullRecord.reserveOptions?.showHoldsInQueue"
              class="record-available text-center"
            >
              <a *ngIf="userData.isStaff" tabindex="0" (agInteract)="holdsInQueue()"
                >{{ fullRecord.reserveOptions.holsInQueueCount }} Hold(s) in Queue</a
              >
              <a *ngIf="userData.isPatron" style="pointer-events: none"
                >{{ fullRecord.reserveOptions.holsInQueueCount }} Hold(s) in Queue</a
              >
            </div>
          </ng-template>
          <!-- Add Item, Place Hold, ILL Request, 3rd Party Integrations, Your-List, Navigation -->
          <div class="record-buttons">
            <div *ngIf="showFulfillmentButton" class="width-100 margin-10-0">
              <button
                *ngIf="!kids; else showKidsButton"
                mat-raised-button
                color="primary"
                type="button"
                [attr.aria-label]="fulfillmentLabel"
                class="ag-mat-button-primary"
                (click)="fulfillItem()"
              >
                {{ this.fulfillmentLabel }}
              </button>
              <ng-template #showKidsButton>
                <img
                  alt="I want it"
                  src="./assets/images/kids-catalog/iwantit.png"
                  style="cursor: pointer"
                  tabindex="0"
                  (agInteract)="fulfillItem()"
                />
              </ng-template>
            </div>
            <ag-online-content *ngIf="!kids" [fullRecord]="fullRecord"></ag-online-content>

            <!-- 3rd Party Integrations -->
            <div *ngIf="fullRecord.targetType === 'BX'">
              <button
                *ngIf="canCheckOutBX"
                type="button"
                aria-label="Checkout Now"
                class="btn btn-primary"
                (click)="checkoutBX()"
              >
                Checkout Now
              </button>
              <button
                *ngIf="BxData?.canHoldBX"
                type="button"
                aria-label="Place Hold"
                class="btn btn-primary"
                (click)="addHoldBX()"
              >
                Place Hold
              </button>
              <button
                *ngIf="canRemoveHoldBX"
                type="button"
                aria-label="Remove Hold"
                class="btn btn-primary"
                (click)="removeHoldBX()"
              >
                Remove Hold
              </button>
            </div>

            <ag-overdrive-fullrecord
              *ngIf="fullRecord.targetType === 'OD' && overDriveItem"
              [item]="overDriveItem"
              [format]="fullRecord.format"
              [isGuest]="userData.isGuest"
              (refreshItem)="refreshItem()"
              (placeHold)="placeOverDriveHold()"
              (selectedProduct)="changeOverdriveJacketArt($event)"
            >
            </ag-overdrive-fullrecord>

            <ag-hoopla-fullrecord
              *ngIf="fullRecord.targetType === 'HP'"
              [item]="hooplaItem"
              [format]="fullRecord.format"
              [purchaseModel]="hooplaPurchaseModel"
              [isGuest]="userData.isGuest"
              (refreshItem)="refreshItem()"
            >
            </ag-hoopla-fullrecord>

            <!-- Action Items -->
            <ag-item-actions-dropdown
              [userData]="userData"
              [fullRecord]="fullRecord"
              [showFormat]="showFormat"
              (addItem)="goToAddItem()"
              (addItemToList)="addToList()"
              (printItem)="print()"
              (emailItem)="email()"
              (multiCopy)="multiCopyForm()"
            >
            </ag-item-actions-dropdown>

            <!-- Guest -->
            <div
              *ngIf="userData.isPatron && fullRecord.targetType === 'BX' && BxData"
              style="font-style: italic"
              class="width-100 padding-0-25"
            >
              <a *ngIf="showMessageBX" class="isDisabled">{{ messageTextBX }}</a>
            </div>
          </div>
        </div>
      </div>

      <!-- desktop - 992px or 1200px  -->
      <div class="container-fluid details-info clearfix">
        <div
          #stickyBlock
          class="record-sticky d-none d-lg-block col-lg-3 pull-left"
          style="width: 240px"
        >
          <!-- JSON details -->
          <div
            *ngIf="fullRecord.author"
            class="record-author text-center author-class"
            [title]="fullRecord.author"
            [innerHTML]="fullRecord.author"
          ></div>
          <h1
            *ngIf="fullRecord.title"
            class="record-title text-center title-class"
            [title]="fullRecord.title"
            [innerHTML]="fullRecord.title"
          ></h1>
          <div
            *ngIf="fullRecord.format"
            class="record-isbn text-center title-class"
            [title]="fullRecord.format"
          >
            <i [ngClass]="'fa ag-media-' + fullRecord.format_Short + ' fa-2x'"></i
            >{{ fullRecord.format }}
          </div>
          <div *ngIf="fullRecord.jacketArt" class="jacketarturl record-image text-center clearfix">
            <ng-container
              *ngTemplateOutlet="jacketArtTemplate; context: { $implicit: fullRecord }"
            ></ng-container>
          </div>
          <div
            *ngIf="fullRecord.format"
            class="record-author text-center title-class no-margin-lineheight1-1"
            [title]="fullRecord.targetName"
            [innerHTML]="'Found In'"
          ></div>
          <div
            *ngIf="fullRecord.format"
            class="record-author text-center foundin-class no-margin-lineheight1-1"
            [title]="fullRecord.targetName"
            [innerHTML]="fullRecord.targetName"
          ></div>
          <div class="record-summary">
            <!-- Our Product Lines AG/AV/ZZ -->
            <div
              *ngIf="fullRecord.targetType === 'AV' && fullRecord.holdings && !kids"
              class="record-available text-center"
            >
              Availability:
              <span *ngIf="fullRecord.holdings?.totalAvailable !== 0">
                {{ fullRecord.holdings?.totalAvailable }}
              </span>
              <span *ngIf="fullRecord.holdings?.totalAvailable === 0"> 0 </span>
              <span *ngIf="fullRecord.holdings?.totalCopies > 0">
                (of {{ fullRecord.holdings?.totalCopies }})</span
              >
              <span *ngIf="fullRecord.holdings?.totalCopies === 0"> (of 0)</span>
            </div>
            <div
              *ngIf="
                (fullRecord.targetType === 'ZZ' || fullRecord.targetType === 'WM') &&
                fullRecord.holdings &&
                !kids &&
                fullRecord.holdings.totalCopies > 0
              "
              class="record-available text-center"
            >
              <!-- DOES NOT LOOK LIKE WE CARRY THAT INFO
                                # Copies Available -->
              Availability:
              <span *ngIf="fullRecord.holdings?.totalAvailable !== 0">
                {{ fullRecord.holdings?.totalAvailable }}
              </span>
              <span *ngIf="fullRecord.holdings?.totalAvailable === 0"> 0 </span>
              <span *ngIf="fullRecord.holdings?.totalCopies">
                (of {{ fullRecord.holdings?.totalCopies }})</span
              >
            </div>

            <!-- 3rd Party Integrations. -->
            <!-- OverDrive -->
            <div
              *ngIf="fullRecord.targetType === 'OD' && fullRecord.details.fields.length > 0"
              class="record-available text-center"
            >
              Availability:
              <span *ngFor="let details of fullRecord.details.fields">
                <span *ngIf="details.name === 'Availability'"> {{ details.value }} </span>
              </span>
            </div>
            <!-- Hoopla -->
            <div *ngIf="fullRecord.targetType === 'HP'" class="record-available text-center">
              Availability: {{ userData.isGuest ? 'Login Required' : hooplaItem?.availability }}
            </div>
            <ng-container *ngIf="fullRecord.targetType === 'HP'; else holdsInQueueNonHoopla">
              <div
                *ngIf="!userData?.isGuest && hooplaPurchaseModel === HOOPLA_TYPE.FLEX"
                class="record-available text-center holds-queue staff-links"
              >
                <a style="pointer-events: none">{{ hooplaItem?.holdsInQueue }} Hold(s) in Queue</a>
              </div>
            </ng-container>
            <ng-template #holdsInQueueNonHoopla>
              <div
                *ngIf="fullRecord.reserveOptions?.showHoldsInQueue"
                class="record-available text-center holds-queue staff-links"
              >
                <a *ngIf="userData.isStaff" tabindex="0" (agInteract)="holdsInQueue()"
                  >{{ fullRecord.reserveOptions.holsInQueueCount }} Hold(s) in Queue</a
                >
                <a *ngIf="userData.isPatron" style="pointer-events: none"
                  >{{ fullRecord.reserveOptions.holsInQueueCount }} Hold(s) in Queue</a
                >
              </div>
            </ng-template>
          </div>

          <!-- Add Item, Place Hold, ILL Request, 3rd Party Integrations, Your-List, Navigation -->
          <div #recordButtons class="record-buttons">
            <div *ngIf="showFulfillmentButton" class="width-100">
              <div class="staff-links width-100 margin-10-0">
                <button
                  *ngIf="!kids; else showKidsButton"
                  mat-raised-button
                  color="primary"
                  type="button"
                  [attr.aria-label]="fulfillmentLabel"
                  class="ag-mat-button-primary"
                  (click)="fulfillItem()"
                >
                  {{ this.fulfillmentLabel }}
                </button>
                <ng-template #showKidsButton>
                  <img
                    alt="I want it"
                    src="./assets/images/kids-catalog/iwantit.png"
                    style="cursor: pointer"
                    tabindex="0"
                    (agInteract)="fulfillItem()"
                  />
                </ng-template>
              </div>
            </div>
            <ag-online-content *ngIf="!kids" [fullRecord]="fullRecord"></ag-online-content>

            <!-- 3rd Party Integrations -->
            <div *ngIf="fullRecord.targetType === 'BX'">
              <button
                *ngIf="canCheckOutBX"
                type="button"
                aria-label="Checkout Now"
                class="btn btn-primary"
                (click)="checkoutBX()"
              >
                Checkout Now
              </button>
              <button
                *ngIf="canHoldBX"
                type="button"
                aria-label="Place Hold"
                class="btn btn-primary"
                (click)="addHoldBX()"
              >
                Place Hold
              </button>
              <button
                *ngIf="canRemoveHoldBX"
                type="button"
                aria-label="Remove Hold"
                class="btn btn-primary"
                (click)="removeHoldBX()"
              >
                Remove Hold
              </button>
            </div>
            <ag-overdrive-fullrecord
              *ngIf="fullRecord.targetType === 'OD' && overDriveItem"
              [item]="overDriveItem"
              [format]="fullRecord.format"
              [isGuest]="userData.isGuest"
              (refreshItem)="refreshItem()"
              (placeHold)="placeOverDriveHold()"
              (selectedProduct)="changeOverdriveJacketArt($event)"
            >
            </ag-overdrive-fullrecord>

            <ag-hoopla-fullrecord
              *ngIf="fullRecord.targetType === 'HP'"
              [item]="hooplaItem"
              [format]="fullRecord.format"
              [purchaseModel]="hooplaPurchaseModel"
              [isGuest]="userData.isGuest"
              (refreshItem)="refreshItem()"
            >
            </ag-hoopla-fullrecord>

            <!-- Staff Actions, Guest, Social Media  -->
            <div class="record-buttons margin-top-10">
              <ag-item-actions-list
                [userData]="userData"
                [fullRecord]="fullRecord"
                [showFormat]="showFormat"
                (addItem)="goToAddItem()"
                (addItemToList)="addToList()"
                (printItem)="print()"
                (emailItem)="email()"
                (multiCopy)="multiCopyForm()"
              >
              </ag-item-actions-list>
            </div>
          </div>
        </div>

        <div class="record-details font-0-9 col-12 col-lg-9 pull-left">
          <!-- Fulrecord tabs null, set your own order -->
          <div *ngIf="!fullRecord.fullRecordSettings.fullRecordTabs">
            <ng-container *ngTemplateOutlet="details"></ng-container>
            <ng-container *ngTemplateOutlet="whereToFindIt"></ng-container>
            <ng-container *ngTemplateOutlet="moreAboutThisTitle"></ng-container>
            <ng-container *ngTemplateOutlet="marcDisplay"></ng-container>
            <ng-container *ngTemplateOutlet="reviews"></ng-container>
            <ng-container *ngTemplateOutlet="shelfBrowse"></ng-container>
            <ng-container *ngTemplateOutlet="syndeticsUnbound"></ng-container>
            <ng-container *ngTemplateOutlet="novelist"></ng-container>
            <ng-container *ngTemplateOutlet="clcd"></ng-container>
          </div>
          <div
            *ngFor="let firstTab of fullRecord.fullRecordSettings.fullRecordTabs"
            [ngSwitch]="firstTab.value"
          >
            <ng-container *ngIf="firstTab.isDefault">
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Details">
                <ng-container *ngTemplateOutlet="details"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.More_About_This_Title">
                <ng-container *ngTemplateOutlet="moreAboutThisTitle"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Where_To_Find">
                <ng-container *ngTemplateOutlet="whereToFindIt"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.GoodreadsReviews">
                <ng-container *ngTemplateOutlet="reviews"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.MARC_Display">
                <ng-container *ngTemplateOutlet="marcDisplay"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Syndetics_Unbound">
                <ng-container *ngTemplateOutlet="syndeticsUnbound"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Novelist">
                <ng-container *ngTemplateOutlet="novelist"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.CLCD">
                <ng-container *ngTemplateOutlet="clcd"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Shelf_Browse">
                <ng-container *ngTemplateOutlet="shelfBrowse"></ng-container>
              </ng-container>
              <ng-template *ngSwitchDefault></ng-template>
            </ng-container>
          </div>
          <div
            *ngFor="let tabs of fullRecord.fullRecordSettings.fullRecordTabs"
            [ngSwitch]="tabs.value"
          >
            <ng-container *ngIf="!tabs.isDefault">
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Details">
                <ng-container *ngTemplateOutlet="details"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.More_About_This_Title">
                <ng-container *ngTemplateOutlet="moreAboutThisTitle"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Where_To_Find">
                <ng-container *ngTemplateOutlet="whereToFindIt"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.GoodreadsReviews">
                <ng-container *ngTemplateOutlet="reviews"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.MARC_Display">
                <ng-container *ngTemplateOutlet="marcDisplay"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Syndetics_Unbound">
                <ng-container *ngTemplateOutlet="syndeticsUnbound"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Novelist">
                <ng-container *ngTemplateOutlet="novelist"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.CLCD">
                <ng-container *ngTemplateOutlet="clcd"></ng-container>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Shelf_Browse">
                <ng-container *ngTemplateOutlet="shelfBrowse"></ng-container>
              </ng-container>
              <ng-template *ngSwitchDefault></ng-template>
            </ng-container>
          </div>

          <!--  ORDER FOR TABS -->
          <!-- Details -->
          <ng-template #details>
            <div *ngIf="fullRecord.details.fields.length" id="details" class="record-group">
              <h2 *ngIf="detailsTabLabel" class="text-center">{{ detailsTabLabel }}</h2>
              <table class="table-sm table-responsive-lg" style="border-color: none">
                <tbody>
                  <tr *ngFor="let field of fullRecord.details.fields">
                    <th scope="row" class="record-detail-desc no-border vertical-top">
                      {{ field.name }}:
                    </th>
                    <td class="no-border">
                      <ng-container *ngIf="field.hyperLink">
                        <ng-container *ngIf="field.value">{{ field.value }} </ng-container>
                        <a
                          [href]="field.hyperLink"
                          target="_blank"
                          class="details-external-link"
                          [matTooltip]="
                            field.hyperLinkText?.length ? field.hyperLinkText : field.hyperLink
                          "
                        >
                          {{
                            field.hyperLinkText?.length
                              ? field.hyperLinkText
                              : (field.hyperLink | truncateUrl)
                          }}
                          <mat-icon class="mat-icon-xs">launch</mat-icon></a
                        >
                      </ng-container>
                      <ng-container *ngIf="field.searchQuery">
                        <a
                          class="active-link"
                          tabindex="0"
                          [innerHTML]="
                            userData.opacOptions.searchResultOptions.enableSearchHightlight
                              ? (field.value
                                | encapsulateSpan: storageService.getItem('Search-TERM'))
                              : field.value
                          "
                          (agInteract)="doSearch(field.searchQuery)"
                        ></a>
                      </ng-container>
                      <ng-container *ngIf="!field.hyperLink && !field.searchQuery">
                        <div
                          [innerHTML]="
                            userData.opacOptions.searchResultOptions.enableSearchHightlight
                              ? (field.value
                                | encapsulateSpan: storageService.getItem('Search-TERM'))
                              : field.value
                          "
                        ></div>
                      </ng-container>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ng-template>

          <!-- Where to Find it -->
          <ng-template #whereToFindIt>
            <div
              *ngIf="
                fullRecord.targetType === 'AG' ||
                fullRecord.targetType === 'AV' ||
                fullRecord.targetType === 'ZZ' ||
                fullRecord.targetType === 'WM'
              "
              id="whereIsIt"
              class="record-group"
            >
              <!-- Locations -->
              <h2 *ngIf="fullRecord.holdings" class="text-center">
                {{ whereToTabLabel }}
              </h2>
              <div
                *ngIf="fullRecord.holdings?.holdingTableMessage !== ''"
                class="text-center holdings-label"
              >
                <i style="text-align: center; vertical-align: middle">{{
                  fullRecord.holdings?.holdingTableMessage
                }}</i>
              </div>
              <!-- For ILL Requests Holdings-->
              <div
                *ngIf="
                  (fullRecord.targetType === 'AG' ||
                    fullRecord.targetType === 'ZZ' ||
                    fullRecord.targetType === 'WM') &&
                  fullRecord.holdings
                "
                class="card"
                [ngClass]="{ 'border-top-0': fullRecord.holdings.holdingTableMessage !== '' }"
              >
                <div *ngIf="fullRecord.holdings" class="card-block record-desc">
                  <table
                    class="table-responsive-lg tablesortNhoney width-100"
                    style="margin-bottom: 0px"
                  >
                    <thead class="thead-check">
                      <tr class="location_title">
                        <ng-container *ngFor="let header of fullRecord.holdings.headers">
                          <ng-container [ngSwitch]="header">
                            <th *ngSwitchCase="'ILL Lender?'">
                              {{
                                fullRecord.fullRecordSettings.lenderColumnLabel
                                  ? fullRecord.fullRecordSettings.lenderColumnLabel
                                  : header
                              }}
                            </th>
                            <th *ngSwitchCase="'colorCode'">
                              <span>&nbsp;</span>
                            </th>
                            <th *ngSwitchDefault>
                              {{ header }}
                            </th>
                          </ng-container>
                        </ng-container>
                      </tr>
                    </thead>
                    <tbody>
                      <!--- one without groups array  -->
                      <tr *ngFor="let holding of fullRecord.holdings?.data" class="row-check-1">
                        <ng-container *ngFor="let item of holding?.item">
                          <td class="column-check" [ngSwitch]="item.name">
                            <span *ngSwitchCase="'ILL Lender?'">
                              {{
                                item.value === '[ILL Lender]'
                                  ? fullRecord.fullRecordSettings.lenderContentsLabel
                                  : item.value
                              }}
                            </span>
                            <span
                              *ngSwitchCase="'SmsText'"
                              style="
                                text-align: center;
                                cursor: pointer;
                                width: 100%;
                                display: inline-block;
                              "
                              tabindex="0"
                              (agInteract)="sendSMS(item.value)"
                            >
                              <i class="fa fa-mobile fa-2x pointer-clean" title="Send SMS"></i>
                            </span>
                            <span
                              *ngSwitchCase="'colorCode'"
                              style="text-align: center; width: 100%; display: inline-block"
                            >
                              <i class="fa fa-circle pointer-clean" [style.color]="item.value"> </i>
                            </span>
                            <span *ngSwitchCase="'Location'">
                              <a
                                *ngIf="
                                  fullRecord.targetType === 'ZZ' || fullRecord.targetType === 'WM'
                                "
                                class="one1"
                                tabindex="0"
                                (agInteract)="getItemHoldings(holding)"
                              >
                                <span *ngIf="!holding?.isMyLibrary" class="holding-details">
                                  {{ item.value | removeEndSpaces }}
                                </span>
                                <span *ngIf="holding?.isMyLibrary" class="holding-details">
                                  {{ item.value | removeEndSpaces }}
                                </span>
                              </a>
                              <a
                                *ngIf="
                                  fullRecord.targetType !== 'ZZ' && fullRecord.targetType !== 'WM'
                                "
                              >
                                {{ item.value | removeEndSpaces }}
                                @if (holding?.isMyLibrary) {
                                  <span class="red"> - {{ 'MY_LIBRARY_OWNS' | translate }}</span>
                                }
                              </a>
                            </span>
                            <span *ngSwitchDefault>
                              <a>
                                {{ item.value | removeEndSpaces }}
                              </a>
                            </span>
                          </td>
                        </ng-container>
                      </tr>
                      <!-- one with groups array -->
                      <ng-template
                        ngFor
                        let-group
                        [ngForOf]="fullRecord.holdings?.groups"
                        class="row-check-2"
                      >
                        <tr style="color: red">
                          {{
                            group.name
                          }}
                        </tr>
                        <tr *ngFor="let data of group.data">
                          <ng-container *ngFor="let d of data.item; let k = index">
                            <ng-container [ngSwitch]="d.name">
                              <td *ngSwitchCase="'ILL Lender?'">
                                {{
                                  d.value === '[ILL Lender]'
                                    ? fullRecord.fullRecordSettings.lenderContentsLabel
                                    : d.value
                                }}
                              </td>
                              <td *ngSwitchCase="'Check Shelf Status'">
                                <span *ngIf="d.value !== null" style="padding-left: 10px">
                                  <span
                                    *ngIf="
                                      statusCodes.get(
                                        sharedService.getValueFromJSON(d.value, 'LibraryCode')
                                      );
                                      else getStatus
                                    "
                                  >
                                    <a class="check-shelfstatus-link">{{
                                      statusCodes.get(
                                        sharedService.getValueFromJSON(d.value, 'LibraryCode')
                                      )
                                    }}</a>
                                  </span>
                                  <ng-template #getStatus>
                                    <a tabindex="0" (agInteract)="showShelfStatus(d.value)"
                                      >Check Shelf Status</a
                                    >
                                  </ng-template>
                                </span>
                              </td>
                              <td *ngSwitchCase="'Map'">
                                <span class="three" style="padding-left: 10px">
                                  <a tabindex="0" (agInteract)="openMap(d.value)">Map</a>
                                </span>
                              </td>

                              <td *ngSwitchDefault>
                                <span style="padding-left: 10px">
                                  <ng-container *ngIf="data?.isMyLibrary; else notMyLibrary">
                                    <!-- 60187 - "My Library" not displaying in full record -->
                                    <a
                                      *ngIf="
                                        k === 0 && fullRecord.targetType === 'AG';
                                        else removeGetItemHoldingsClickAction
                                      "
                                      tabindex="0"
                                      [ngClass]="{ 'holding-details': k === 0 }"
                                      (agInteract)="getItemHoldings(data)"
                                    >
                                      {{ d.value | removeEndSpaces }}
                                      @if (d.showLibraryText) {
                                        <span class="red"> - {{ 'MY_LIBRARY_OWNS' | translate }}</span>
                                      }
                                    </a>
                                    <ng-template #removeGetItemHoldingsClickAction>
                                      <a>
                                        {{ d.value | removeEndSpaces }}
                                        @if (d.showLibraryText) {
                                          <span class="red"> - {{ 'MY_LIBRARY_OWNS' | translate }}</span>
                                        }
                                      </a>
                                    </ng-template>
                                  </ng-container>
                                  <ng-template #notMyLibrary>
                                    <a
                                      *ngIf="k === 0 && fullRecord.targetType === 'AG'; else notAG"
                                      tabindex="0"
                                      [ngClass]="{ 'holding-details': k === 0 }"
                                      (agInteract)="getItemHoldings(data)"
                                    >
                                      {{ d.value }}
                                    </a>
                                    <ng-template #notAG>
                                      <a>
                                        {{ k === 0 ? d.value : (d.value | removeEndSpaces) }}
                                      </a>
                                    </ng-template>
                                  </ng-template>
                                </span>
                              </td>
                            </ng-container>
                          </ng-container>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- ILS Holdings -->
              <div *ngIf="fullRecord.targetType === 'AV' && fullRecord.holdings" class="card">
                <div *ngIf="fullRecord.holdings?.data.length > 0" class="card-block record-desc">
                  <table
                    class="table-responsive-lg tablesortNhoney width-100"
                    style="margin-bottom: 0px"
                  >
                    <thead>
                      <tr
                        *ngIf="fullRecord.holdings?.headers && fullRecord.holdings?.headers[0]"
                        class="location_title"
                      >
                        <th *ngFor="let header of fullRecord.holdings?.headers">
                          <span *ngIf="header !== 'colorCode'">{{ header }}</span>
                          <span *ngIf="header === 'colorCode'">&nbsp;</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody
                      *ngIf="fullRecord.holdings?.data && fullRecord.holdings?.data.length > 0"
                    >
                      <tr *ngFor="let holding of fullRecord.holdings?.data">
                        <td *ngFor="let item of holding?.item">
                          <span
                            *ngIf="item?.name === 'SmsText'"
                            style="
                              text-align: left;
                              cursor: pointer;
                              width: 100%;
                              display: inline-block;
                              margin-left: 16%;
                            "
                            tabindex="0"
                            (agInteract)="sendSMS(item.value)"
                          >
                            <i class="fa fa-mobile fa-2x pointer-clean" title="Send SMS"></i>
                          </span>
                          <span
                            *ngIf="item?.name === 'colorCode'"
                            style="text-align: center; width: 100%; display: inline-block"
                          >
                            <i class="fa fa-circle pointer-clean" [style.color]="item.value"> </i>
                          </span>
                          <span
                            *ngIf="item?.name === 'Edit Item' && userData.isStaff"
                            style="text-align: left; width: 100%; display: inline-block"
                          >
                            <button
                              *ngIf="item?.value"
                              role="button"
                              type="button"
                              aria-label="Edit Item"
                              class="btn btn-link"
                              (click)="goToEditItem(item.value)"
                            >
                              Edit Item
                            </button>
                          </span>
                          <span
                            *ngIf="item?.name === 'Status'"
                            style="text-align: left; width: 100%; display: inline-block"
                          >
                            <button
                              *ngIf="checkKey(item) && userData.isStaff"
                              role="button"
                              type="button"
                              aria-label="Status"
                              class="btn btn-link"
                              style="text-decoration: underline !important"
                              (click)="
                                openIframeModule(item.hyperLink, 'Circulation > Item Status')
                              "
                            >
                              {{ item.value }}
                            </button>
                            <div *ngIf="!checkKey(item) && userData.isStaff">
                              {{ item.value }}
                            </div>
                            <div *ngIf="!userData.isStaff">{{ item.value }}</div>
                          </span>
                          <span *ngIf="item?.name === 'Call Number'" title="{{ item.value }}">{{
                            item.value.length > 24
                              ? (item.value | slice: 0 : 24) + '...'
                              : item.value
                          }}</span>
                          <span
                            *ngIf="
                              item?.name !== 'Call Number' &&
                              item?.name !== 'SmsText' &&
                              item?.name !== 'colorCode' &&
                              item?.name !== 'Edit Item' &&
                              item?.name !== 'Status'
                            "
                            >{{ item.value }}</span
                          >
                        </td>
                      </tr>
                      <ng-template ngFor let-group [ngForOf]="fullRecord.holdings?.groups">
                        <tr style="color: red">
                          {{
                            group.name
                          }}
                        </tr>
                        <tr *ngFor="let data of group.data">
                          <td *ngFor="let d of data.item">
                            <span *ngIf="d.name === 'Check Shelf Status' && d.value" class="one">
                              <span
                                *ngIf="
                                  statusCodes.get(
                                    sharedService.getValueFromJSON(d.value, 'LibraryCode')
                                  );
                                  else getStatus
                                "
                              >
                                <a class="check-shelfstatus-link">{{
                                  statusCodes.get(
                                    sharedService.getValueFromJSON(d.value, 'LibraryCode')
                                  )
                                }}</a>
                              </span>
                              <ng-template #getStatus>
                                <a tabindex="0" (agInteract)="showShelfStatus(d.value)"
                                  >Check Shelf Status</a
                                >
                              </ng-template>
                            </span>
                            <span
                              *ngIf="d.name !== 'Map' && d.name !== 'Check Shelf Status'"
                              class="two"
                              >{{ d.value }}</span
                            >
                            <span *ngIf="d.name === 'Map'" class="three">
                              <a tabindex="0" (agInteract)="openMap(d.value)">Map</a>
                            </span>
                          </td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- MARC DISPLAY -->
          <ng-template #marcDisplay>
            <ng-container
              *ngIf="fullRecord.fullRecordSettings.displayMARC && fullRecord.marc && !kids"
            >
              <div id="marc" class="record-group">
                <div class="width-100">
                  <h2 *ngIf="marcTabLabel" class="text-center">
                    {{ marcTabLabel }}
                  </h2>
                  <div class="card">
                    <div class="card-block record-desc">
                      <label
                        *ngIf="
                          fullRecord.agControlId &&
                          (fullRecord.targetType === 'AG' || fullRecord.targetType === 'AV')
                        "
                        for="controlNumber"
                      >
                        <strong id="controlNumber">Control Number : </strong>
                        {{ fullRecord.agControlId }}
                      </label>
                      <br />
                      <label
                        *ngIf="
                          fullRecord.lastModified &&
                          (fullRecord.targetType === 'AG' || fullRecord.targetType === 'AV')
                        "
                        for="lastModified"
                      >
                        <strong id="lastModified">Last Modified : </strong>
                        {{ fullRecord.lastModified.length > 0 ? fullRecord.lastModified[0] : '' }}
                      </label>
                      <br />
                      <label *ngIf="fullRecord.marc.record.leader" for="leader">
                        <strong id="leader">Leader : </strong>
                        {{ fullRecord.marc.record.leader }}
                      </label>
                      <br />
                      <label
                        *ngIf="
                          fullRecord.quality.toString() &&
                          (fullRecord.targetType === 'AG' || fullRecord.targetType === 'AV')
                        "
                        for="quality"
                      >
                        <strong id="quality">Quality : </strong>
                        {{ fullRecord.quality }}
                      </label>
                      <table
                        class="table-responsive-lg tablesortNhoney width-100"
                        style="margin-bottom: 0px"
                      >
                        <tbody>
                          <tr *ngFor="let record of fullRecord.marc.record.fields">
                            <td *ngFor="let key of record | keys">{{ key }}</td>
                            <td *ngFor="let key of record | keys" style="width: 4%">
                              <span *ngIf="record[key].ind1 && record[key].ind2">
                                <span *ngFor="let d of record[key].ind1 | keys">
                                  {{ record[key].ind1[d] | removeWhiteSpaces }}
                                </span>
                                <span *ngFor="let d of record[key].ind2 | keys">
                                  {{ record[key].ind2[d] | removeWhiteSpaces }}
                                </span>
                              </span>
                            </td>
                            <td *ngFor="let key of record | keys">
                              <span *ngIf="!record[key].subfields">
                                {{ record[key] }}
                              </span>
                              <span *ngIf="record[key].subfields">
                                <span *ngFor="let d of record[key].subfields">
                                  <span *ngFor="let abc of d | keys">
                                    <span
                                      *ngIf="
                                        userData?.opacOptions.searchResultOptions
                                          .enableSearchHightlight
                                      "
                                      ><b><span [innerHTML]="abc + '&nbsp;'"></span> </b>
                                      <span
                                        class="new-span"
                                        [tabindex]="d[abc].includes('http') ? 0 : -1"
                                        [innerHTML]="
                                          d[abc]
                                            | highlightsSearchTerm
                                              : storageService.getItem('Search-TERM')
                                        "
                                        [ngClass]="{ 'main-link': d[abc].includes('http') }"
                                        (agInteract)="openLink(d[abc])"
                                        >{{ d[abc] }}</span
                                      >
                                    </span>
                                    <span
                                      *ngIf="
                                        !userData?.opacOptions.searchResultOptions
                                          .enableSearchHightlight
                                      "
                                    >
                                      <b>
                                        {{ abc }}
                                      </b>
                                      <span
                                        [tabindex]="d[abc].includes('http') ? 0 : -1"
                                        [ngClass]="{ 'main-link': d[abc].includes('http') }"
                                        (agInteract)="openLink(d[abc])"
                                      >
                                        {{ d[abc] }}
                                      </span>
                                    </span>
                                  </span>
                                </span>
                              </span>
                            </td>
                            <td>
                              <b style="background: #008000"></b>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-template>

          <!-- Shelf Browse -->
          <ng-template #shelfBrowse>
            <div
              *ngIf="
                fullRecord.fullRecordSettings.displayShelfBrowse && fullRecord.shelfBrowseLocations
              "
              id="shelf"
              class="record-group shelf-browse text-center"
            >
              <h2 *ngIf="shelfTabLabel" class="text-center">{{ shelfTabLabel }}</h2>
              <p>
                “Shelf browsing is most useful if you are browsing a single location and not the
                whole library system.”
              </p>
              <div class="dropdown-container text-center">
                <span class="pull-none">
                  <select
                    #option
                    aria-label="select a location"
                    title="Select a Location"
                    class="select-locations"
                    [ngModel]="shelfLibraryValue"
                    (ngModelChange)="getShelfNewLoc(option.value)"
                  >
                    <option *ngFor="let option of shelfBrowseLocations" [value]="option.locationId">
                      {{ option.locationName }}
                    </option>
                  </select>
                </span>
              </div>
              <br />
              <br />
            </div>
            <!-- Slick Gallery -->

            <ag-carousel [slideCount]="8">
              @for (carouselItem of shelfBrowseItems; track carouselItem) {
                <ag-carousel-item
                  [carouselItem]="carouselItem"
                  (selectedCarouselItem)="selectedCarouselItem($event)"
                  showCallNumber
                >
                  <div
                    *ngIf="userData && systemCategory === SYSTEMCATEGORY.VERSO"
                    class="text-center"
                  >
                    <button
                      *ngIf="
                        (fullRecord.targetType === 'AG' ||
                          fullRecord.targetType === 'AV' ||
                          fullRecord.targetType === 'ZZ') &&
                        (userData.isStaff ? true : allowPatronGuestReserve)
                      "
                      type="button"
                      class="action-icon-button"
                      aria-label="Place Hold"
                      mat-icon-button
                      matTooltip="Place Hold"
                      matTooltipPosition="below"
                      (agInteract)="
                        actionOnShelfBrowseEvent({ action: 'placehold', item: carouselItem })
                      "
                    >
                      <mat-icon svgIcon="finger"></mat-icon>
                    </button>
                    <button
                      type="button"
                      class="action-icon-button"
                      aria-label="Add to List"
                      mat-icon-button
                      matTooltip="Add to List"
                      matTooltipPosition="below"
                      (agInteract)="
                        actionOnShelfBrowseEvent({ action: 'addToList', item: carouselItem })
                      "
                    >
                      <i class="fa fa-list-alt" aria-hidden="true"></i>
                    </button>
                    <button
                      type="button"
                      class="action-icon-button"
                      aria-label="View Details"
                      mat-icon-button
                      matTooltip="View Details"
                      matTooltipPosition="below"
                      (agInteract)="
                        actionOnShelfBrowseEvent({ action: 'details', item: carouselItem })
                      "
                    >
                      <i class="fa fa-info" aria-hidden="true"></i>
                    </button>
                  </div>
                </ag-carousel-item>
              }
            </ag-carousel>
          </ng-template>
          <!-- Top 5 Reviews -->

          <!-- More About This Title -->
          <ng-template #moreAboutThisTitle>
            <div *ngIf="showMoreAboutThisTitle" id="moreAbout" class="record-group">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-12" style="margin-top: 15px">
                    <div *ngIf="fullRecord.moreAboutThisTitleOptions.showSyndetics">
                      <h2 *ngIf="moreAboutTabLabel" class="text-center">{{ moreAboutTabLabel }}</h2>
                      <div id="syn_summary" aria-label="syn_summary"></div>
                      <div id="syn_anotes" aria-label="syn_anotes"></div>
                      <div class="review-link" [hidden]="showMoreSY">
                        <a
                          class="show-more-fewer"
                          tabindex="0"
                          (agInteract)="toggleShowMoreInfo('more')"
                          >show More</a
                        >
                      </div>
                      <div class="review-link" [hidden]="!showFewerSY">
                        <a
                          class="show-more-fewer"
                          tabindex="0"
                          (agInteract)="toggleShowMoreInfo('less')"
                          >show Fewer</a
                        >
                      </div>
                      <div [hidden]="!showFewerSY">
                        <div id="syn_awards" aria-label="syn_awards"></div>
                        <div id="syn_blreview" aria-label="syn_blreview"></div>
                        <div id="syn_abreview" aria-label="syn_abreview"></div>
                        <div id="syn_chreview" aria-label="syn_chreview"></div>
                        <div id="syn_criticasreview" aria-label="syn_criticasreview"></div>
                        <div id="syn_dbchapter" aria-label="syn_dbchapter"></div>
                        <div id="syn_gmsummary" aria-label="syn_gmsummary"></div>
                        <div id="syn_hbreview" aria-label="syn_hbreview"></div>
                        <div id="syn_itasummary" aria-label="syn_itasummary"></div>
                        <div id="syn_kireview" aria-label="syn_kireview"></div>
                        <div id="syn_ljreview" aria-label="syn_ljreview"></div>
                        <div id="syn_nyreview" aria-label="syn_nyreview"></div>
                        <div id="syn_pwreview" aria-label="syn_pwreview"></div>
                        <div id="syn_sljreview" aria-label="syn_sljreview"></div>
                        <div id="syn_series" aria-label="syn_series"></div>
                        <div id="syn_spreview" aria-label="syn_spreview"></div>
                        <div id="syn_spsummary" aria-label="syn_spsummary"></div>
                        <div id="syn_swedreview" aria-label="syn_swedreview"></div>
                        <div id="syn_swedsummary" aria-label="syn_swedsummary"></div>
                        <div id="syn_swedtoc" aria-label="syn_swedtoc"></div>
                        <div id="syn_toc" aria-label="syn_toc"></div>
                        <div id="syn_fiction" aria-label="syn_fiction"></div>
                        <div id="syn_avprofile" aria-label="syn_avprofile"></div>
                        <div id="syn_avsummary" aria-label="syn_avsummary"></div>
                        <div id="syn_video_clip" aria-label="syn_video_clip"></div>
                      </div>
                      <div class="review-link" [hidden]="!showFewerSY">
                        <a
                          class="show-more-fewer"
                          tabindex="0"
                          (agInteract)="toggleShowMoreInfo('less')"
                          >show Fewer</a
                        >
                      </div>
                    </div>
                    <div *ngIf="contentCafeData">
                      <h2 *ngIf="moreAboutTabLabel" class="text-center">{{ moreAboutTabLabel }}</h2>
                      <div *ngFor="let item of contentCafeData; index as i">
                        <div *ngIf="i <= 1" class="less-2">
                          <h5>{{ item?.name }}</h5>
                          <div *ngFor="let data of item?.value">
                            <p [innerHTML]="data"></p>
                          </div>
                        </div>
                        <div *ngIf="i > 1 && showMoreCF" class="greater-2">
                          <h5>{{ item?.name }}</h5>
                          <div *ngFor="let data of item?.value">
                            <p [innerHTML]="data"></p>
                          </div>
                        </div>
                      </div>
                      <div *ngIf="contentCafeData.length > 2 && !showMoreCF" class="less-2">
                        <a class="show-more-fewer" tabindex="0" (agInteract)="toggleShowCF('more')"
                          >show More</a
                        >
                      </div>
                      <div *ngIf="contentCafeData.length > 2 && showFewerCF" class="greater-2">
                        <a class="show-more-fewer" tabindex="0" (agInteract)="toggleShowCF('less')"
                          >show Fewer</a
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <!-- Good Read Reviews -->
          <ng-template #reviews>
            <span *ngIf="fullRecord.fullRecordSettings.displayGoodreadsReview">
              <div
                *ngIf="fullRecord.reviews?.goodReadReviewData"
                style="width: 100%; margin-top: 15px; margin-bottom: 5%"
              >
                <h2 id="reviews" style="text-align: center">Goodreads® Reviews</h2>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-12" style="margin-top: 15px; height: 80vh">
                      <div
                        *ngIf="fullRecord.reviews?.goodReadReviewData?.divData"
                        class="full-width-div"
                        id="good-read-rev"
                        [innerHTML]="fullRecord.reviews.goodReadReviewData.divData | santizeValue"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </ng-template>

          <!-- SYNDETICS UNBOUND -->
          <ng-template #syndeticsUnbound>
            <syndetics-fullrecord
              *ngIf="showSyndeticsUnbound && fullRecord.isbn"
              [isbn]="fullRecord.isbn"
              [label]="syndeticsTabLabel"
              [id]="userData.syndeticsUnboundId"
            >
            </syndetics-fullrecord>
          </ng-template>

          <!-- NOVELIST -->
          <ng-template #novelist>
            <novelist-fullrecord
              *ngIf="fullRecord.fullRecordSettings.displayNovelist && fullRecord.isbn && !kids"
              id="novel"
              [isbn]="fullRecord.isbn"
              [label]="novelistTabLabel"
            >
            </novelist-fullrecord>
          </ng-template>
          <!-- CLCD -->
          <ng-template #clcd>
            <ag-clcd
              *ngIf="showClcd"
              id="clcd"
              [clcd]="fullRecord.clcdGuid"
              [label]="clcdTabLabel"
              [searchId]="searchId"
              (contentLoaded)="clcdLoaded = $event"
            >
            </ag-clcd>
          </ng-template>
        </div>
        <!-- END - Categories - All Devices -->
      </div>
    </div>

    <ag-page-sticky *ngIf="scrolled" position="bottom-right" [offset]="[18, 18]">
      <ng-container *ngIf="(layoutService.screenRange$ | async).ltMd; else goToTop">
        <!-- Section Jump -->
        <button
          mat-fab
          [matMenuTriggerFor]="sectionMenu"
          [@fadeInOut]
          type="button"
          class="ag-mat-button-primary"
        >
          <mat-icon>expand_less</mat-icon>
        </button>
        <mat-menu #sectionMenu="matMenu" [overlapTrigger]="false" yPosition="above">
          <ng-container
            *ngFor="let fullRecordTab of fullRecord.fullRecordSettings.fullRecordTabs"
            [ngSwitch]="fullRecordTab.value"
          >
            <ng-container *ngIf="fullRecordTab.isDefault">
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Details">
                <!-- details scroll to link -->
                <button
                  *ngIf="detailsTabLabel"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('details')"
                >
                  {{ detailsTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.More_About_This_Title">
                <!-- more about this title scroll to link -->
                <button
                  *ngIf="showMoreAboutThisTitle"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('moreAbout')"
                >
                  {{ moreAboutTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Where_To_Find">
                <!-- where to find it scroll link -->
                <button
                  *ngIf="fullRecord.holdings"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('whereIsIt')"
                >
                  {{ whereToTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.GoodreadsReviews">
                <!-- review scroll to link -->
                <button
                  *ngIf="
                    fullRecord.fullRecordSettings.displayGoodreadsReview &&
                    fullRecord.reviews?.goodReadReviewData
                  "
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('reviews')"
                >
                  Goodreads® Reviews
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.MARC_Display">
                <!-- marc display scroll to link -->
                <button
                  *ngIf="fullRecord.fullRecordSettings.displayMARC && !kids && marcTabLabel"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('marc')"
                >
                  {{ marcTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Syndetics_Unbound">
                <!-- syndetics display scroll to link -->
                <button
                  *ngIf="showSyndeticsUnbound && !kids"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('syndetics_unbound')"
                >
                  {{ syndeticsTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Novelist">
                <!-- novelist display scroll to link -->
                <button
                  *ngIf="fullRecord.fullRecordSettings.displayNovelist && !kids"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('novel')"
                >
                  {{ novelistTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.CLCD">
                <!-- clcd display scroll to link -->
                <button
                  *ngIf="showClcd && clcdLoaded"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('clcd')"
                >
                  {{ clcdTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Shelf_Browse">
                <!-- shelf browse scroll to link -->
                <button
                  *ngIf="
                    fullRecord.shelfBrowseLocations &&
                    fullRecord.fullRecordSettings.displayShelfBrowse &&
                    shelfTabLabel
                  "
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('shelf')"
                >
                  {{ shelfTabLabel }}
                </button>
              </ng-container>
              <ng-template *ngSwitchDefault>
                <!-- required so the switch does not hard break -->
              </ng-template>
            </ng-container>
          </ng-container>
          <ng-container
            *ngFor="let firstTab of fullRecord.fullRecordSettings.fullRecordTabs"
            [ngSwitch]="firstTab.value"
          >
            <ng-container *ngIf="!firstTab.isDefault">
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Details">
                <!-- details scroll to link -->
                <button
                  *ngIf="detailsTabLabel"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('details')"
                >
                  {{ detailsTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.More_About_This_Title">
                <!-- more about this title scroll to link -->
                <button
                  *ngIf="showMoreAboutThisTitle"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('moreAbout')"
                >
                  {{ moreAboutTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Where_To_Find">
                <!-- where to find it scroll link -->
                <button
                  *ngIf="fullRecord.holdings"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('whereIsIt')"
                >
                  {{ whereToTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.GoodreadsReviews">
                <!-- review scroll to link -->
                <button
                  *ngIf="
                    fullRecord.fullRecordSettings.displayGoodreadsReview &&
                    fullRecord.reviews?.goodReadReviewData
                  "
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('reviews')"
                >
                  Goodreads® Reviews
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.MARC_Display">
                <!-- marc display scroll to link -->
                <button
                  *ngIf="fullRecord.fullRecordSettings.displayMARC && !kids && marcTabLabel"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('marc')"
                >
                  {{ marcTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Syndetics_Unbound">
                <!-- syndetics display scroll to link -->
                <button
                  *ngIf="showSyndeticsUnbound && !kids"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('syndetics_unbound')"
                >
                  {{ syndeticsTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Novelist">
                <!-- novelist display scroll to link -->
                <button
                  *ngIf="fullRecord.fullRecordSettings.displayNovelist && !kids"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('novel')"
                >
                  {{ novelistTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.CLCD">
                <!-- clcd display scroll to link -->
                <button
                  *ngIf="showClcd && clcdLoaded"
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('clcd')"
                >
                  {{ clcdTabLabel }}
                </button>
              </ng-container>
              <ng-container *ngSwitchCase="fullRecordOptionTabs.Shelf_Browse">
                <!-- shelf browse scroll to link -->
                <button
                  *ngIf="
                    fullRecord.shelfBrowseLocations &&
                    fullRecord.fullRecordSettings.displayShelfBrowse &&
                    shelfTabLabel
                  "
                  mat-menu-item
                  type="button"
                  (click)="scrollToSectionById('shelf')"
                >
                  {{ shelfTabLabel }}
                </button>
              </ng-container>
              <ng-template *ngSwitchDefault>
                <!-- required so the switch does not hard break -->
              </ng-template>
            </ng-container>
          </ng-container>
          <button *ngIf="scrolled" mat-menu-item type="button" (click)="scrollToTop()">
            Back to Top
          </button>
        </mat-menu>
      </ng-container>
      <ng-template #goToTop>
        <button
          *ngIf="scrolled"
          mat-fab
          [@fadeInOut]
          type="button"
          class="ag-mat-button-primary"
          (click)="scrollToTop()"
        >
          <mat-icon>expand_less</mat-icon>
        </button>
      </ng-template>
    </ag-page-sticky>

    <ag-page-sticky *ngIf="!loading && searchId" position="bottom" [offset]="[18, 0]">
      <div class="pagination-wrapper mat-elevation-z2">
        <button
          mat-button
          type="button"
          aria-label="Previous Title"
          matTooltip="Previous Title"
          [disabled]="!hasPreviousAgControlId"
          (click)="goToAgControlId('previous')"
        >
          <mat-icon>skip_previous_icon</mat-icon>
        </button>
        <button
          mat-button
          type="button"
          aria-label="Next Title"
          matTooltip="Next Title"
          [disabled]="!hasNextAgControlId"
          (click)="goToAgControlId('next')"
        >
          <mat-icon>skip_next_icon</mat-icon>
        </button>
      </div>
    </ag-page-sticky>
  </div>
</ng-container>
